"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationCancellationInfoDto = instanceOfOrientationCancellationInfoDto;
exports.OrientationCancellationInfoDtoFromJSON = OrientationCancellationInfoDtoFromJSON;
exports.OrientationCancellationInfoDtoFromJSONTyped = OrientationCancellationInfoDtoFromJSONTyped;
exports.OrientationCancellationInfoDtoToJSON = OrientationCancellationInfoDtoToJSON;
exports.OrientationCancellationInfoDtoToJSONTyped = OrientationCancellationInfoDtoToJSONTyped;
const ShiftCancellationReason_1 = require("./ShiftCancellationReason");
const ProfileNameDto_1 = require("./ProfileNameDto");
/**
 * Check if a given object implements the OrientationCancellationInfoDto interface.
 */
function instanceOfOrientationCancellationInfoDto(value) {
    if (!('cancellationDate' in value) || value['cancellationDate'] === undefined)
        return false;
    if (!('cancellationReason' in value) || value['cancellationReason'] === undefined)
        return false;
    if (!('cancellationComment' in value) || value['cancellationComment'] === undefined)
        return false;
    if (!('canceledByProfile' in value) || value['canceledByProfile'] === undefined)
        return false;
    return true;
}
function OrientationCancellationInfoDtoFromJSON(json) {
    return OrientationCancellationInfoDtoFromJSONTyped(json, false);
}
function OrientationCancellationInfoDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'cancellationDate': (json['cancellationDate'] == null ? null : new Date(json['cancellationDate'])),
        'cancellationReason': (0, ShiftCancellationReason_1.ShiftCancellationReasonFromJSON)(json['cancellationReason']),
        'cancellationComment': json['cancellationComment'],
        'canceledByProfile': (0, ProfileNameDto_1.ProfileNameDtoFromJSON)(json['canceledByProfile']),
    };
}
function OrientationCancellationInfoDtoToJSON(json) {
    return OrientationCancellationInfoDtoToJSONTyped(json, false);
}
function OrientationCancellationInfoDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'cancellationDate': (value['cancellationDate'] == null ? null : value['cancellationDate'].toISOString()),
        'cancellationReason': (0, ShiftCancellationReason_1.ShiftCancellationReasonToJSON)(value['cancellationReason']),
        'cancellationComment': value['cancellationComment'],
        'canceledByProfile': (0, ProfileNameDto_1.ProfileNameDtoToJSON)(value['canceledByProfile']),
    };
}
//# sourceMappingURL=OrientationCancellationInfoDto.js.map